import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  FeedbackDashboardItemSchema,
  FeedbackDetailSchema,
  FeedbackListParams,
  FeedbackNoteSchema,
  FeedbackStatus,
  SendEmailResponse
} from '@app/core/api/manager-feedback';

export const ManagerFeedbackActions = createActionGroup({
  source: 'Manager Feedback',
  events: {
    // Load feedback list
    'Load Feedback List': props<{ params?: FeedbackListParams }>(),
    'Load Feedback List Success': props<{
      items: FeedbackDashboardItemSchema[];
      total: number;
      page: number;
      size: number;
      pages: number;
    }>(),
    'Load Feedback List Failure': props<{ error: string }>(),

    // Load feedback detail
    'Load Feedback Detail': props<{ id: string }>(),
    'Load Feedback Detail Success': props<{ feedback: FeedbackDetailSchema }>(),
    'Load Feedback Detail Failure': props<{ error: string }>(),

    // Update status
    'Update Status': props<{ id: string; status: FeedbackStatus }>(),
    'Update Status Success': props<{ feedback: FeedbackDashboardItemSchema }>(),
    'Update Status Failure': props<{ error: string }>(),

    // Add note
    'Add Note': props<{ id: string; text: string }>(),
    'Add Note Success': props<{ note: FeedbackNoteSchema }>(),
    'Add Note Failure': props<{ error: string }>(),

    // Send email
    'Send Email': props<{ id: string; subject: string; body: string }>(),
    'Send Email Success': props<{ response: SendEmailResponse }>(),
    'Send Email Failure': props<{ error: string }>(),

    // Delete feedback
    'Delete Feedback': props<{ id: string }>(),
    'Delete Feedback Success': props<{ id: string }>(),
    'Delete Feedback Failure': props<{ error: string }>(),

    // Delete note
    'Delete Note': props<{ feedbackId: string; noteId: string }>(),
    'Delete Note Success': props<{ feedbackId: string; noteId: string }>(),
    'Delete Note Failure': props<{ error: string }>(),

    // Filters
    'Set Filters': props<{ filters: FeedbackListParams }>(),

    // Clear selected
    'Clear Selected Feedback': emptyProps(),

    // Clear errors
    'Clear Errors': emptyProps(),
  }
});
